import AbsenceAlert from "@/features/pages/Home/AbsenceAlert/AbsenceAlert"
import MissedTasksAlert from "@/features/pages/Home/MissedTasksAlert/MissedTasksAlert"
import AchievementFlair from "@/features/pages/Home/AchievementFlair/AchievementFlair"
import Feedback from "@/features/pages/Home/Feedback/Feedback"
import LatestLectures from "@/features/pages/Home/HomeLatestLectures/LatestLectures"
import Leaderboard from "@/features/pages/Home/Leaderboard/Leaderboard"
import TopOne from "@/features/pages/Home/TopOne/TopOne"

export default function Home() {
  return (
    <div className="d-flex flex-column gap-4 pb-4">
      <TopOne />
      <AchievementFlair />
      <AbsenceAlert />
      <MissedTasksAlert />
      <LatestLectures />
      <Leaderboard />
      <Feedback />
    </div>
  )
}
